import {theme} from '../../../theme';
import {Divider} from '../../atoms/Divider/Divider';
import {ViewerSettingDividerProps} from './ViewerSettingDividerProps.interface';

export function ViewerSettingDivider({isMobile}: ViewerSettingDividerProps) {
  return (
    <Divider
      color={theme.colors['theme-transparent-20']}
      className={isMobile ? 'my-20pxr' : 'my-10pxr'}
    />
  );
}
